<template>
	<div  class="wid100" v-show="show" v-loading="loading">
		<!-- 跟进  -->
		
		<div v-if="datalist.length" class="drawerpage"  >
			<div class="follow_box1" v-for="(item1,index1) in datalist">
				<div class="follow_tit1">
					{{item1.title || ''}}
				</div>
					
				<div class="follow_box2" v-for="(item2, index2) in item1.children">
					<div class="follow_tit2 ">
						
						<img :src="urlhead + '/pctime.png'" mode="aspectFit"></img>
						<span >
							{{item2.title || ''}}
						</span>
					</div>
					<div class="follow_item" v-for="(item3, index3) in item2.children">
						
						<div class="ri_content">
							
							<div class="timetil">
								<div class="timetil_left Flexalign">
									<span>
										{{item3.time3 || ''}}
									</span>
									<span>
										{{item3.way_name || ''}}
									</span>
									<span>
										|
									</span>
									<span>
										{{item3.type_name || ''}}
									</span>
								</div>
								
								
								<div class="laizi">
									来自客户：
									<span>
										{{item3.customer_name || ''}}
									</span>
								</div>
							</div>
							<div class="contets" v-html="item3.content ">
								<!-- {{item3.content || ''}} -->
							</div>
							
						</div>
						<div class="content_bom">
							<div class="txt">
								由{{item3.member_name || ''}}跟进
								<template v-if="item3.assistant_member_id">
									,
									<span
										v-for="(val, ind) in item3.assistant_member_name">
										{{val}} 
										<template v-if="ind != item3.assistant_member_name.length - 1">
											、
										</template>
										</span>协同
								</template>
							</div>
							<div class="czuo">
								<span @click="fn_edit_gen(index1, index2, index3, 1)">
									<i style="color:rgba(42, 117, 234, 1)" class="el-icon-edit-outline"></i>
								</span>
								<span @click="fn_edit_gen(index1, index2, index3, 2)">
									<i style="color:rgba(229, 80, 57, 1)" class="el-icon-delete"></i>
								</span>
										
							</div>
						</div>
											
					
					</div>
				</div>
			</div>
			
			
			<div class="btn_right" >
				<div >
					<el-pagination background layout="total,sizes, prev, pager, next" prev-text="上一页"
						next-text="下一页" :page-sizes="[10,20, 50, 100]" :page-size="pagesize" :current-page="page"
						:pager-count='5' @size-change="type_modify_page" @current-change="type_switch_page"
						:total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		
		
		<!-- 没有数据 -->
		<template v-else>
			<nodata :show="true"></nodata>
		</template>
		<!--  -->
		
		<!-- 编辑跟进 -->
		<Dialog :show.sync="edit_genj" :name_width="genj_dialog" :appendtobody="true">
			<span slot="body">
		
				<el-input type="textarea" :rows="5" resize="none" placeholder="请输入内容" class="input_w560"
					v-model="edit_genj_obj.content">
				</el-input>
		
			</span>
		
			<div class="dialog-footer" slot="footer">
				<el-button type="primary" @click="genjsave">确 认</el-button>
				<el-button @click="edit_genj = false">取 消</el-button>
			</div>
		</Dialog>
		<!--  -->

	</div>
</template>

<script>
	var that
	
	import {
	
		getrecord_list2,
		
	} from 'network/hk_operset'
	import {
		edit_follow_record,
		delCustomerFollowRecord,
	} from 'network/hk_customer'
	
	import {
		retujudpower,
		retupower,
		alertMess,
	} from '@src/network/kh_public'
	
	import Dialog from "components/content/dialog/Dialog";
	import nodata from "@/components/content/publics/nodata.vue";
	export default {
		components: {
			Dialog,
			nodata,
		},
		
		name: "followupbox",
		props: {
			// 
			ispowerEdit:{
				type: Boolean,
				default: true,
			},
			ispowerDel:{
				type: Boolean,
				default: true,
			},
			
			customer_id: {
				type: Number,
				default: 0,
			},
			chance_id: {
				type: Number,
				default: 0,
			},
			contract_id: {
				type: Number,
				default: 0,
			},
			return_id: {
				type: Number,
				default: 0,
			},
			project_id: {
				type: Number,
				default: 0,
			},
			
			contact_id: {
				type: Number,
				default: 0,
			},
			
			order_id: {
				type: Number,
				default: 0,
			},
			
			
			quotation_id: {
				type: Number,
				default: 0,
			},
			
			
			show: {
				type: Boolean,
				default: false,
			},
			
			
			
			
		},
		watch: {
			show(){
				this.datalist = []
				if(this.show) {
					this.Refresh()
				}
			},
		},
		data() {
			return {
				
				edit_genj_obj: '',
				edit_genj: false,
				genj_dialog: {
					name: '编辑跟进',
					width: '400px'
				},
			
				
				urlhead: 'https://scrm.51kuaiding.com/scrm/hktxcx/customer',
				
				
				
				pagesize: 10,
				page: 1,
				total: 0,
				
				datalist: [],
				
				loading: true,
			}
		},

		created() {
			that = this
			// 
			this.Refresh()
			
		},
		
		methods: {
			Refresh(){
				console.log('Refresh')
				this.pagesize = 10
				this.page = 1
				this.total = 0
				this.fn_Grecordlist()
			},
			
			
			fn_edit_gen(index1, index2, index3, flag) {
				let obj = this.datalist[index1].children[index2].children[index3]
				if(obj) {
					if (flag == 1) { // 编辑跟进
						// if(retujudpower(this.ispowerEdit)) {
							
						// }
						this.edit_genj = true
						this.edit_genj_obj = JSON.parse(JSON.stringify(obj))
						
					} else { // 删除跟进
						// if(retujudpower(this.ispowerDel)) {
							
						// }
						this.fn_delFollow(obj.id)
					}
				}
			},
			// 修改 跟进记录
			genjsave(){
				let obj = this.edit_genj_obj
				// let data = {
				// 	id: obj.id,	// 是	int	跟进记录id
				// 	content: obj.content,	// 否	string	内容
				// }
				let fd = new FormData();
				fd.append('id', obj.id) 
				fd.append('content', obj.content) 
				edit_follow_record(fd).then(res => {
					if (this.handlereq(res)) {
						this.alertMess('修改成功', 'success')
						this.fn_Grecordlist()
						this.edit_genj = false
					}
				})
			},
			// 删除 跟进记录
			fn_delFollow(id) {
				this.$confirm('您确定删除吗?')
					.then(() => {
						delCustomerFollowRecord(id).then(res => {
							if (this.handlereq(res)) {
								this.alertMess('删除成功', 'success')
								this.fn_Grecordlist()
							}
						})
					}).catch(() => {});
				
			},
			
			// 获取客户详情页 -- 客户跟进
			fn_Grecordlist() {
				this.loading = true
				this.datalist = []
				let data = {
					page : this.page,
					pagesize : this.pagesize,
					class_type: 0,
					sort_type: 1,
				}
				
				if(this.customer_id) {
					data.customer_id = this.customer_id
				}
				if(this.chance_id) {
					data.chance_id = this.chance_id
				}
				if(this.contract_id) {
					data.contract_id = this.contract_id
				}
				if(this.return_id) { 
					data.return_id = this.return_id
				}
				if(this.project_id) {
					data.project_id = this.project_id
				}
				if(this.contact_id) {
					data.contact_id = this.contact_id
				}
				if(this.order_id) {
					data.order_id = this.order_id
				}
				if(this.quotation_id) {
					data.quotation_id = this.quotation_id
				}
				
				
				
				getrecord_list2(data).then(res => {
					this.datalist = []
					if (this.handlereq(res)) {
						let obj = res.result
						this.total = obj.total
						if (obj.data) {
						
							for (let item of obj.data) {
								
								let s1 = item.follow_time.split(' ')
			
								let s2 = s1[0].split('-') // 2022 07 30
			
								let s3 = s1[1].slice(0, 5) // 11:50 
			
								item.time1 = `${s2[0]}年${s2[1]}月`
								item.time2 = `${s2[1]}月${s2[2]}日`
								item.time3 = s3
			
			
								let flag1 = this.datalist.some(v => v.title == item.time1)
								let index1 = this.datalist.findIndex(v => v.title == item.time1)
								if (flag1) {
									// 找得到
									let obj2 = this.datalist[index1].children
									let flag2 = obj2.some(v => v.title == item.time2)
									let index2 = obj2.findIndex(v => v.title == item.time2)
			
									if (flag2) {
										// 找得到
										let obj3 = obj2[index2].children
										obj3.push(item)
									} else {
										// 找不到
										let newEle = {
											title: item.time2,
											children: [],
										}
										newEle.children.push(item)
										obj2.push(newEle)
									}
								} else {
									// 找不到
									let newEle = {
										title: item.time1,
										children: [{
											title: item.time2,
											children: [],
										}]
									}
									newEle.children[0].children.push(item)
									this.datalist.push(newEle)
								}
			
							}
						}
					}
					this.loading = false
					let len = this.total || 0;
					this.$emit('retnum', len)
				})
			},
			


			// 切换页码1
			type_modify_page(val) {
				this.pagesize = val
				this.page = 1
				this.fn_Grecordlist()
			},
			type_switch_page(val) {
				this.page = val
				this.fn_Grecordlist()
			},

			// 弹出提示
			alertMess(message, type) {
				this.$message({
					showClose: true,
					offset: 100,
					duration: 2000,
					message,
					type: type ? type : 'success',
				});
			},
			handlereq(res) {
				if (res) {
					if (res.code === 10000) { // 请求成功
						return true
					} else { // 请求发生错误
						this.alertMess(res.message, 'error')
						return false
					}
				}
			},


		}
	}
</script>

<style scoped lang="scss">
	
	
	
	.btn_right{
		width: 100%;
		display:flex;
		justify-content: flex-end;
		margin-top: 20px;
		position: sticky;
		bottom: 0;
		background: #fff;
		padding: 10px 0;
		z-index: 20;
	}
	.follow_box1 {
		width: 100%;
		margin-bottom: 30px;
		.follow_tit1 {
			position: relative;
			font-size: 16px;
			color: rgba(56, 56, 56, 1);
			display: flex;
			align-items: center;
			margin-bottom: 30px;
		}
	
		.follow_tit1::before {
			content: '';
			display: block;
			width: 3px;
			height: 20px;
			margin-right: 7px;
			background: rgba(43, 117, 235, 1);
		}
	
		.follow_box2 {
			// padding-left: 20px;
	
			.follow_tit2 {
				display:flex;
				margin-top: 38px;
				margin-bottom: 5px;
				img{
					width: 16px;
					height: 16px;
					display:block;
					margin-right: 10px;
				}
				span{
					font-size: 14px;
					color: #000;
					
					
				}
				
			}
			
			.follow_item {
				position: relative;
				padding: 0 25px;
				padding-top: 20px;
				.ri_content::before{
					content:'';
					position: absolute;
					display:block;
					width: 10px;
					height: 10px;
					background: rgba(248, 249, 251, 1);
					transform: rotate(45deg);
					left: -5px;
					top: 12px;
					
				}
				.ri_content {
					position: relative;
					padding: 18px;
					width: 100%;
					border-radius: 6px;
					opacity: 1;
					background: rgba(248, 249, 251, 1);
					
					.timetil{
						display:flex;
						align-items: center;
						justify-content: space-between;
						.laizi{
							display:flex;
							align-items: center;
							font-size: 12px;
							color: rgba(166, 166, 166, 1);
							span{
								font-size: 12px;
								color:rgba(43, 117, 235, 1);
							}
						}
						.timetil_left{
							span{
								font-size: 14px;
								color: rgba(56, 56, 56, 1);
								margin-right: 10px;
							}
						}
						
						.txts{
							font-size: 14px;
							color: rgba(128, 128, 128, 1);
							>span{
								font-size: 14px;
								color: rgba(56, 56, 56, 1);
							}
						}
					}
					.contets {
						margin-top: 11px;
						font-size: 14px;
						color: rgba(56, 56, 56, 1);
	
						padding: 8px 18px;
						width: 100%;
						border-radius: 5px;
						background: #fff;
					}
	
					
				}
				.content_bom {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-top: 10px;
					
					.txt {
						font-size: 12px;
						color: rgba(128, 128, 128, 1);
					}
					
					.czuo {
						display: flex;
						align-items: center;
					
						span {
							cursor: pointer;
							margin-left: 10px;
						}
					
						i {
							font-size: 20px;
						}
					}
				}
								
			}
			
			
			.follow_item::before{
				position: absolute;
				content:'';
				display:block;
				left: 8px;
				top: 0;
				height: 100%;
				width: 1px;
				background-color: rgba(243, 243, 243, 1);
				z-index: 2;
			}
			.follow_item::after{
				position: absolute;
				content:'';
				display:block;
				left: 5px;
				top: 33px;
				border-radius: 100%;
				height: 7px;
				width: 7px;
				z-index: 3;
				background-color: rgba(42, 117, 234, 1);
			}
		
		}
	}
	
	
</style>
